import { ContractPopupRepository } from "../domain/ContractPopupRepository";
import { FileRepository } from "../../shared/domain/FileRepository";
import { ContractPopup } from "../domain/ContractPopup";
import { ServiceDeliveryRepository } from "../domain/ServiceDeliveryRepository";
import { GetExtraUsersDataQuery } from '@/modules/revenue/app/GetExtraUsersDataQuery';
import { UpdateExtraUsersDataQuery } from '@/modules/revenue/app/UpdateExtraUsersDataQuery';
import { GetExtraUsersTotalPriceQuery  } from '@/modules/revenue/app/GetExtraUsersTotalPriceQuery';

export class ContractPopupAllCommands{
    screen_data: ContractPopup;
    contract_popup_repo: ContractPopupRepository;
    file_repo: FileRepository;
    sd_repo: any;
    constructor(screen_data, contract_popup_repo: ContractPopupRepository, file_repo: FileRepository, sd_repo: ServiceDeliveryRepository){
        this.screen_data = screen_data
        this.contract_popup_repo = contract_popup_repo
        this.file_repo = file_repo
        this.sd_repo = sd_repo
    }

    addComputedFields(user_data, contract_modal_msg, contract_modal_distributor, contract_modal_facturae_client, contract_modal_working_hours_client, is_company_selector_visible, is_tax_data_filled, can_show_document_services_and_banks){
        this.screen_data.user_data = user_data
        this.screen_data.contract_modal_msg = contract_modal_msg
        this.screen_data.contract_modal_distributor = contract_modal_distributor
        this.screen_data.contract_modal_facturae_client = contract_modal_facturae_client
        this.screen_data.contract_modal_working_hours_client = contract_modal_working_hours_client
        this.screen_data.is_company_selector_visible = is_company_selector_visible
        this.screen_data.is_tax_data_filled = is_tax_data_filled
        this.screen_data.can_show_document_services_and_banks = can_show_document_services_and_banks
    }

    calculateContractDate(){
        const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth()
        const year = today.getFullYear();
        this.screen_data.contract_date = day + ' de ' + months[month] + ' de ' + year
    }

    calculateEndDate(){
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        this.screen_data.end_date = day + '/' + month + '/' + (year + 1);
    }

    is_distributor() {
        return this.screen_data.user_data.distributor_code && this.screen_data.contract_modal_distributor;
    }
    
    async getDistributorUsers(){
        if (this.is_distributor()) {
            const args = {}
            const result = await this.contract_popup_repo.getDistributorUsers(args)
            this.screen_data.distributor_users = result
        }
    }

    async getClientUsers(){
        if (this.screen_data.contract_modal_facturae_client) {
            const args = {}
            const result = await this.contract_popup_repo.getClientUsers(args)
            this.screen_data.client_users_facturae = result
        }
    }

    services_to_display(){
        if (this.screen_data.contract_modal_working_hours_client && this.screen_data.is_company_selector_visible) {
            return ["working_hours"];
        }
        if (this.screen_data.contract_modal_facturae_client || this.screen_data.is_company_selector_visible) {
            return ["facturae_credits"];
        }
        if ((this.screen_data.user_data.distributor_code && this.screen_data.contract_modal_distributor) || this.screen_data.can_show_document_services_and_banks) {
            return ["documents", "banks"];
        }
        let aux = [];
        if (this.screen_data.user_data.available_features['feature_defaulter_user'] || this.screen_data.user_data.available_features['feature_contract_is_going_to_finish'] || this.screen_data.user_data.available_features['feature_trial_contract_is_finished']) {
            aux.push("documents");
        }
        if (this.screen_data.user_data.available_features['feature_bank_contract_finished'] || this.screen_data.user_data.available_features['feature_bank_contract_is_going_to_finish'] || this.screen_data.user_data.available_features['feature_bank_trial_contract_is_finished']) {
            aux.push("banks");
        }
        if (this.screen_data.user_data.available_features['feature_show_triangle_contracts'] ){ //refactor in progress
            aux.push("credits");
        }
        if (this.screen_data.user_data.available_features['feature_can_buy_facturae'] ){
            aux.push("facturae_credits");
        }
        // Mostrar working_hours si tiene el feature activo o si el trial ha expirado
        if (this.screen_data.user_data.available_features['feature_clock_in'] || this.screen_data.user_data.available_features['feature_working_hours_trial_contract_is_finished']) {
            aux.push("working_hours");
        }
        return aux;
    }

    getTaxes() {
        const plans = Object.values(this.screen_data.services)
        if (this.screen_data.services && plans[0] && plans[0][0]){
            this.screen_data.taxes.name = plans[0][0]["tax_name"]
            this.screen_data.taxes.percentage = Math.round(plans[0][0]["tax_rate"] * 10000) / 100
            this.screen_data.taxes.added = this.screen_data.taxes.name === 'IVA'? true : false
        }
    }

    validateThePromotionalCode(){
        if(this.screen_data.promotional_code){
            // Check if ANY service type has a valid promotional code
            let isValidCode = false;
            for (const serviceType of Object.values(this.screen_data.services)) {
                if (serviceType && serviceType.length > 0 && serviceType[0]["is_valid_code"]) {
                    isValidCode = true;
                    break;
                }
            }

            if(isValidCode){
                this.screen_data.success_message_for_promotional_code = "El código ha sido aplicado con éxito"
                this.screen_data.error_message_for_promotional_code = ""
            }else{
                this.screen_data.success_message_for_promotional_code = ""
                this.screen_data.error_message_for_promotional_code = "El código usado no es válido"
                this.screen_data.key_promotional_code++
            }
        }else{
            // Clear messages when promotional code field is empty
            this.screen_data.success_message_for_promotional_code = ""
            this.screen_data.error_message_for_promotional_code = ""
        }
    }

    getExtraUsersTotalPrice(key): number {        
        const item = this.screen_data.extraUsersScreenData[key];
        if (item.show && item.selected_extra_users && item.extra_users_price) {
            return item.selected_extra_users * item.extra_users_price;
        }
        return 0;
    }

    calculateTotalToPay() {
        let total = 0.0;
        this.screen_data.any_plan_selected = false;
        if (Object.values(this.screen_data.selected_services).some(service => service.selected_plan_name !== "")) {
            for (const [key, value] of Object.entries(this.screen_data.services)){
                for(const plan of this.screen_data.services[key]){
                    if(plan.service_id == this.screen_data.selected_services[key].service_id){
                        this.screen_data.any_plan_selected = true;
                        let extraUsersTotalPrice = 0
                        if(this.screen_data.user_data.available_features['feature_purchase_extra_users']) {
                            extraUsersTotalPrice = this.getExtraUsersTotalPrice(key)
                        }
                        if(key == 'facturae_credits'){
                            total += (plan.price * this.screen_data.companies_eInvoice) + extraUsersTotalPrice
                        }else{
                            total += plan.price + extraUsersTotalPrice
                        }
                    }
                }
            }
        }
        total = this.screen_data.taxes.added? ((this.screen_data.taxes.percentage / 100) + 1) * total: total;
        this.screen_data.total_price = total;
    }

    async getServices(){
        this.screen_data.is_services_loading = true
        const args = {
            kinds: this.services_to_display(),
            promotional_code: this.screen_data.promotional_code
        }
        const result = await this.contract_popup_repo.getServices(args)
        this.screen_data.services = result
        this.screen_data.is_services_loading = false
        this.getTaxes()
        this.validateThePromotionalCode()
        this.calculateTotalToPay()
    }

    select_customer() {
        return this.screen_data.contract_modal_facturae_client && this.screen_data.user_data && this.screen_data.user_data.user_role.value != 'customer' && this.screen_data.user_data.user_role.value != 'customer_consult'
    }

    change_view_text(view, result?){
        switch(view){
            case "select_plan":
                if (this.select_customer()) {
                    this.screen_data.card_title = "Selecciona un usuario cliente para contratarle la Factura Electrónica";
                }
                else {
                    this.screen_data.card_title = "Selecciona el plan que quieres contratar";    
                }
                break
            case "select_payment_method":
                this.screen_data.card_title = "Método de pago";
                break
            case "waiting_screen":
                this.screen_data.card_title = "Procesando el pago";

                if(this.screen_data.payment_method == "transfer"){
                    this.screen_data.title = "Cargando..."
                    this.screen_data.message = "Por favor, espera un momento."
                }else if(this.screen_data.payment_method == "card"){
                    if(this.screen_data.used_card.use_old_card){
                        this.screen_data.title  = 'Conectando con Stripe...'
                        this.screen_data.message = "Por favor, espera un momento."
                    }else{
                        this.screen_data.title  = 'Tiempo restante para completar el pago'
                        this.screen_data.message = 'Tu información será procesada de forma segura a través de Stripe, completa los datos en la ventana emergente.'
                    }
                }
                break
            case "final_result_screen":
                if(this.screen_data.payment_method == "transfer"){
                    if(result == "ok"){
                        this.screen_data.card_title = "Transferencia exitosa";
                        this.screen_data.success = true
                        this.screen_data.title  = '¡Transferencia realizada con éxito!';
                        this.screen_data.message = `Agradecemos tu confianza en Inmatic y nos alegra contar contigo. En unos minutos podrás encontrar tu recibo en el área de cliente, dentro de la sección 'Mis Datos'. Si necesitas ayuda o deseas más información, no dudes en contactarnos.`;
                    }else if(result == "waiting_screen") {
                        this.screen_data.card_title = "Tiempo de espera";
                        this.screen_data.success = false
                        this.screen_data.title  = '¡No se pudo realizar la transferencia!';
                        this.screen_data.message = "Has realizado una compra del mismo servicio en los últimos 30 minutos. Por favor, inténtalo de nuevo más tarde.";
                    }else{
                        this.screen_data.card_title = "Transferencia fallida";
                        this.screen_data.success = false
                        this.screen_data.title  = 'La transferencia no pudo ser procesada';
                        this.screen_data.message = 'Lamentamos informarte que no pudimos completar la transacción. Esto puede deberse a un error con el método de pago o a una conexión interrumpida. Te recomendamos verificar los datos ingresados o intentar nuevamente.';
                    }
                }else if(this.screen_data.payment_method == "card"){
                    if(result == "ok"){
                        this.screen_data.card_title = "Pago exitoso";
                        this.screen_data.success = true;
                        this.screen_data.title  = '¡Pago realizado con éxito!'
                        this.screen_data.message = `Agradecemos tu confianza en Inmatic y nos alegra contar contigo. En unos minutos podrás encontrar tu recibo en el área de cliente, dentro de la sección 'Mis Datos'. Si necesitas ayuda o deseas más información, no dudes en contactarnos.`
                    }else if(result == "finished_time"){
                        this.screen_data.card_title = "Tiempo excedido para el pago";
                        this.screen_data.success = false
                        this.screen_data.title  = 'Tiempo excedido para el pago';
                        this.screen_data.message = 'Se ha superado el tiempo máximo para completar el pago. Por favor, inténtalo de nuevo.';
                    }else{
                        this.screen_data.card_title = "Pago con tarjeta incorrecto";
                        this.screen_data.success = false
                        this.screen_data.title  = 'La transferencia no pudo ser procesada'
                        this.screen_data.message = 'Lamentamos informarte que no pudimos completar el pago. Esto puede deberse a un error con el método de pago o a una conexión interrumpida. Te recomendamos verificar los datos ingresados o intentar nuevamente.'
                    }
                }
                break
        }
        this.screen_data.view = view
    }

    selectOneService(serviceType){
        // Para facturae y working hours, inicialmente 1 empresa
        if (serviceType === 'facturae_credits' || serviceType === 'working_hours') {
            this.screen_data.companies_eInvoice = 1;
        }
        if (this.screen_data.services[serviceType] && this.screen_data.services[serviceType].length > 0) {
            this.screen_data.selected_services[serviceType].selected_plan_name = this.screen_data.services[serviceType][0].name;
            this.screen_data.selected_services[serviceType].service_id = this.screen_data.services[serviceType][0].service_id;
        }
        this.calculateTotalToPay()
    }

    selectOneFacturaE(){
        this.selectOneService('facturae_credits')
    }

    isAvailableTheIncrementerOfCompanies(){
        return this.select_customer() || (this.screen_data.is_company_selector_visible && !this.screen_data.contract_modal_working_hours_client)
    }

    async run(){
        this.calculateContractDate()
        this.calculateEndDate()

        await this.getDistributorUsers()
        await this.getClientUsers()

        await this.getServices()

        if (this.select_customer()) {
            this.selectOneFacturaE()
        }

        if(this.screen_data.is_company_selector_visible){
            // Seleccionar el primer plan según el tipo
            if (this.screen_data.contract_modal_working_hours_client) {
                this.selectOneService('working_hours')
            } else {
                this.selectOneFacturaE()
            }
            const args = {}
            const companies = await this.contract_popup_repo.getUserCompanies(args)
            this.screen_data.user_companies = companies
        }
        //evento para cuando saber la respuesta de stripe cuando se abre su mini ventana
        await this.rememberUsedCard();
        this.screen_data.message_listener = (event) => {
            if (event.data.stripe_result){
                this.screen_data.waiting_time = this.screen_data.default_waiting_time
                this.change_view_text("final_result_screen", event.data.stripe_result)
            }
        }
        window.addEventListener('message', this.screen_data.message_listener)
    }

    getServiceName(type, short=false) {
        switch(type) {
            case 'documents':
                return 'Facturas'
            case 'banks':
                return 'Bancos';
            case 'credits':
                return !short? 'Gestor Documental':'Gestor Doc.';
            case 'facturae_credits':
                return !short? 'Factura Electrónica':'FACTURA E.';
            case 'working_hours':
                return 'Control Horario';
            default:
                return 'error';
        } 
    }

    getServiceType(type) {
        switch(type) {
            case 'documents':
                return 'Documentos'
            case 'banks':
                return 'Movimientos';
            case 'credits':
                return "Créditos";
            case 'facturae_credits':
                return "";
            case 'working_hours':
                return "";
            default:
                return 'error';
        } 
    }

    coin_format(value) {
        let coin = '';
        if (!(value === 0 || value === 0.0 || value === '' || value === null || value === undefined)) {
            const isInteger = Number(value) % 1 === 0;
            coin =  Number(value).toLocaleString('es-ES', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: isInteger ? 0 : 2,
                maximumFractionDigits: 2
            });
        }
        return coin;
    }

    getDescriptionOfThePlan(service_name, plan){
        if (service_name == "facturae_credits"){
            return plan.yearly_text.replaceAll("x", plan.price+"€")
        }

        return plan.yearly
    }

    toggleDropdown(service_name) {
        for (const [key, value] of Object.entries(this.screen_data.selected_services)){
            if(key == service_name){
                this.screen_data.selected_services[key].dropdown = !this.screen_data.selected_services[key].dropdown
            }else{
                this.screen_data.selected_services[key].dropdown = false
            }
        }
        if(service_name == "facturae_credits"){
            this.screen_data.is_open_info_extra_companies = true
        }else{
            this.screen_data.is_open_info_extra_companies = false
        }
        this.screen_data.is_open_info_extra_users = false
    }

    async togglePlanSelection(key, clicked_plan) {
        if (this.screen_data.selected_services[key].selected_plan_name != clicked_plan.name) {
            this.screen_data.selected_services[key].selected_plan_name = clicked_plan.name;
            this.screen_data.selected_services[key].service_id = clicked_plan.service_id;
            this.screen_data.selected_services[key].price = clicked_plan.price;
            this.screen_data.selected_services[key].extra_users_price = clicked_plan.extra_users_price
            this.screen_data.is_open_info_extra_users = true
        } else {
            this.screen_data.selected_services[key].selected_plan_name = '';
            this.screen_data.selected_services[key].service_id = null;
            this.screen_data.selected_services[key].price = 0;
        }


        if (this.screen_data.user_data.available_features['feature_purchase_extra_users']) {
            let getExtraUsersDataQuery = new GetExtraUsersDataQuery(this.sd_repo, this.screen_data.extraUsersScreenData);
            await getExtraUsersDataQuery.execute(clicked_plan);
        }
        this.calculateTotalToPay()
    }

    updateNumExtraUsers(kind, delta) {
        const updateExtraUsers = new UpdateExtraUsersDataQuery(this.screen_data.extraUsersScreenData);
        updateExtraUsers.execute(kind,delta);
        this.calculateTotalToPay()
    }

    async validateSelectPlan(){
        await this.getServices()
        if (!this.screen_data.error_message_for_promotional_code){
            this.screen_data.view = "select_payment_method"
        }
    }

    isNextButtonEnabled() {
        if (this.select_customer()) {
            return this.screen_data.user_id_to_deliver_facturae ? this.screen_data.any_plan_selected : false;
        }
        else if (this.is_distributor()) {
            return this.screen_data.user_id_to_deliver_contract ? this.screen_data.any_plan_selected : false;
        } else if(this.screen_data.user_companies.length > 0){
            return Boolean(this.screen_data.selected_company_id) && this.screen_data.any_plan_selected
        }
        return this.screen_data.any_plan_selected;
    }

    changeThePaymentMethod(method) {
        this.screen_data.payment_method = method
    }

    toggleSummaryDisplayed() {
        this.screen_data.isSummaryDisplayed = !this.screen_data.isSummaryDisplayed;
        this.screen_data.is_auto_renewal_displayed = false
    }

    toggleAutoRenewalDisplayed() {
        this.screen_data.is_auto_renewal_displayed = !this.screen_data.is_auto_renewal_displayed;
        this.screen_data.isSummaryDisplayed = false
    }

    getSelectedServiceIds(){
        let services_ids = []
        for (const service of Object.values(this.screen_data.selected_services)){
            if(service.service_id){
                services_ids.push(service.service_id)
            }
        }
        return services_ids
    }

    getServicesIdsAndIsAutoRenewalsActives(){
        let services_ids_and_is_auto_renewals_actives = []
        for (const service of Object.values(this.screen_data.selected_services)){
            if(service.service_id){
                let service_id_and_is_auto_renewal_active = {
                    service_id: service.service_id,
                    is_auto_renewal_active: service.is_auto_renewal_active,
                }
                services_ids_and_is_auto_renewals_actives.push(service_id_and_is_auto_renewal_active)
            }
        }
        return services_ids_and_is_auto_renewals_actives
    }

    onFileChange() {
        this.screen_data.file_added = this.screen_data.payment_file instanceof File
    }

    getServicesForLegalContract(){
        let services_for_legal_contract = []
        for (const [key, values] of Object.entries(this.screen_data.services)){
            for (const plan of values){
                for (const service_id of this.getSelectedServiceIds()){
                    if(service_id == plan.service_id){
                        const service_for_legal_contract = {
                            id: plan.service_id,
                            name: this.getServiceName(key) + " - " + plan.name,
                            price: plan.price,
                            quantity: key == "facturae_credits"? plan.total_credits : plan.yearly,
                        }
                        services_for_legal_contract.push(service_for_legal_contract)
                    }
                }
            }
        }
        return services_for_legal_contract
    }

    several_selected_plans() {
        let count = 0;
        Object.values(this.screen_data.selected_services).forEach((service) => {
            if (service.selected_plan_name !== '') {
                count ++
            }
        });
        return count > 1
    }

    getSummaryDescription(service_name, plan){
        switch(service_name){
            case "documents":
                return plan.yearly + " docs/año"
            case "banks":
                return plan.yearly + " movs/año"
            case "credits":
                return plan.yearly + " crédits/año"
            case "facturae_credits":
                return plan.yearly + " emp/año"
            case "working_hours":
                return ""
            default:
                return "ERROR"
        }

    }

    isContinuePaymentWithTransEnabled() {
        return this.screen_data.payment_method == "transfer" && this.screen_data.file_added && this.screen_data.is_the_contract_accepted;
    }

    decrease_waiting_time() {
        if (this.screen_data.waiting_time > 0) {
            this.screen_data.waiting_time--;
        } else {
            this.change_view_text("final_result_screen", "finished_time")
            clearInterval(this.screen_data.timer_interval_id);
            this.screen_data.waiting_time = this.screen_data.default_waiting_time;
        }   
    }

    remaining_clock() {
        const min = Math.floor(this.screen_data.waiting_time / 60);
        const sec = this.screen_data.waiting_time % 60;
        return min.toString().padStart(2, '0')+":"+sec.toString().padStart(2, '0');
    }

    getSelectedServiceExtraUserData() {
        const result = {};
        Object.keys(this.screen_data.selected_services).forEach(index => {
            const selectedPlanName = this.screen_data.selected_services[index].selected_plan_name;
            if (selectedPlanName !== '') {
                const selectedPlan = this.screen_data.services[index].find(plan => plan.name === selectedPlanName);
                if (selectedPlan) {
                    const extraUsers = this.screen_data.extraUsersScreenData[index].selected_extra_users || 0;
                    result[selectedPlan.service_id] = extraUsers;
                }
            }
        });
        return result;
    }

    async payWithTransfer() {
        this.change_view_text("waiting_screen")
        let payment_file_path = await this.file_repo.uploadFile(this.screen_data.payment_file);
        if (!this.screen_data.payment_file || !(this.screen_data.payment_file instanceof File)) {
            throw new Error("El archivo proporcionado no es válido.");
        }

        let user_id_to_delivery = null
        if (this.screen_data.user_id_to_deliver_facturae){
            user_id_to_delivery = this.screen_data.user_id_to_deliver_facturae
        }else if(this.screen_data.user_id_to_deliver_contract){
            user_id_to_delivery = this.screen_data.user_id_to_deliver_contract
        }
        const args = {
            payment_file_path,
            services: this.getServicesIdsAndIsAutoRenewalsActives(),
            num_credits_custom: this.screen_data.companies_eInvoice,
            promotional_code: this.screen_data.promotional_code,
            user_id_to_delivery: user_id_to_delivery,
            company_id_to_facturae: this.screen_data.selected_company_id,
            extra_users: this.getSelectedServiceExtraUserData()
        };
        let response = await this.contract_popup_repo.payWithTransfer(args)

        if (response && response.output && response.output.success) {
            this.change_view_text("final_result_screen", "ok")
        } else {
            if(response && response.output && response.output.message && response.output.message.includes("Error")){
                this.change_view_text("final_result_screen", "error")
            }else{
                this.change_view_text("final_result_screen", "waiting_screen")
            }
        }
        this.screen_data.payment_file = null
    }

    async rememberUsedCard() {
        const args = {}
        const response = await this.contract_popup_repo.rememberUsedCard(args)
        if(!response){
            return
        }
        this.screen_data.used_card.stripe_customer_id = response.card_data.stripe_customer_id
        this.screen_data.used_card.payment_method_id = response.card_data.payment_method_id
        this.screen_data.used_card.last4 = response.card_data.last4
        this.screen_data.used_card.use_old_card = response.card_data.use_old_card
    }

    async payWithCard() {
        this.change_view_text("waiting_screen")
        this.screen_data.waiting_time = this.screen_data.default_waiting_time;
        if (this.screen_data.used_card.use_old_card) {
            await this.payWithSavedCard();
        } else {
            await this.payWithNewCard();
        }
    }

    async payWithSavedCard() {
        const args = {
            services: this.getServicesIdsAndIsAutoRenewalsActives(),
            stripe_customer_id: this.screen_data.used_card.stripe_customer_id,
            payment_method_id: this.screen_data.used_card.payment_method_id,
            user_id_to_deliver: this.screen_data.user_id_to_deliver_contract,
            num_credits_custom: this.screen_data.companies_eInvoice,
            promotional_code: this.screen_data.promotional_code,
            company_id_to_facturae: this.screen_data.selected_company_id,
            extra_users: this.getSelectedServiceExtraUserData()
        }
        const response = await this.contract_popup_repo.payWithSavedCard(args)
        this.change_view_text("final_result_screen", response.output.status)
    }

    async payWithNewCard() {
        let user_id_to_delivery = null
        if (this.screen_data.user_id_to_deliver_facturae){
            user_id_to_delivery = this.screen_data.user_id_to_deliver_facturae
        }else if(this.screen_data.user_id_to_deliver_contract){
            user_id_to_delivery = this.screen_data.user_id_to_deliver_contract
        }

        const args = {
            services: this.getServicesIdsAndIsAutoRenewalsActives(),
            stripe_customer_id: this.screen_data.used_card.stripe_customer_id,
            promotional_code: this.screen_data.promotional_code,
            user_id_to_deliver: user_id_to_delivery,
            num_credits_custom: this.screen_data.companies_eInvoice,
            company_id_to_facturae: this.screen_data.selected_company_id,
            extra_users: this.getSelectedServiceExtraUserData()
        }
        const response = await this.contract_popup_repo.payWithNewCard(args)
        window.open(response.output.url, '_blank', 'width=388, height=689');
        
        if (this.screen_data.timer_interval_id) {
            clearInterval(this.screen_data.timer_interval_id);
        }

        this.screen_data.timer_interval_id = setInterval(() => {
            this.decrease_waiting_time();
        }, 1000);
    }

    changeDropdown(service_name){
        for(let service_key of Object.keys(this.screen_data.selected_services)){
            if(service_key == service_name){
                this.screen_data.selected_services[service_key].dropdown = true
            }else{
                this.screen_data.selected_services[service_key].dropdown = false
            }
        }
    }

    toggleIsOpenInfoExtraCompanies(service_name){
        this.changeDropdown(service_name)
        this.screen_data.is_open_info_extra_companies = true
        this.screen_data.is_open_info_extra_users = false
    }

    toggleIsOpenInfoExtraUsers(service_name){
        this.changeDropdown(service_name)
        this.screen_data.is_open_info_extra_users = true
        this.screen_data.is_open_info_extra_companies = false
    }

    // AIDAAAAAAAAAAAAA
    hasVisibleExtraUsers() {
        return true;
        // return Object.values(this.screen_data.extraUsersScreenData).some(item => item.show);
    }

    toggleIsAutoRenewalActive(key){
        this.screen_data.selected_services[key].is_auto_renewal_active = !this.screen_data.selected_services[key].is_auto_renewal_active
    }
}